import logo from "../logo.svg";
import "../App.css";

function HomePage() {
  return (
    <div className="App">
      <div>
        <h1><b>Bienvenido a Futbolero<img style={{height: 80, width: 80}} src="./Images/arbitro.png"/></b></h1>
        <h5>La plataforma para armar la reta con tus compas</h5>
      </div>
    </div>
  );
}

export default HomePage;
